import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { CaDesignModule } from '../../ca-design/ca-design.module';

/**
 * For any post with media marked as sensitive, this acts as a parent wrapper to display a blur.
 *
 * @param enabled Bypass this wrapper entirely by setting to false
 * @param allowReveal When true, the user can tap to reveal the content.
 *   In some cases (eg notification list), we don't want to show the reveal button.
 * @param blockBackgroundClicks When true, clicks on the blurred area are intercepted
 *   (so we don't launch the memo detail lightbox). When false, clicks pass through (eg feed routing)
 * @param borderRadius Allows us to match the border radius of the image we're wrapping
 */
@Component({
  selector: 'sensitive-media-blur',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslateModule, CaDesignModule],
  templateUrl: './sensitive-media-blur.component.html',
  styleUrls: ['./sensitive-media-blur.component.scss'],
})
export class SensitiveMediaBlurComponent {
  @Input() borderRadius?: string;
  @Input() enabled = false;
  @Input() allowReveal = true;
  @Input() blockBackgroundClicks = false;

  @HostBinding('class.sensitiveMediaBlur--active')
  get active(): boolean {
    return this.enabled;
  }

  @HostBinding('style.--sensitive-media-border-radius')
  get borderRadiusVar(): string | null {
    return this.borderRadius ?? null;
  }

  revealed = false;

  reveal(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.revealed = true;
  }

  conceal(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.revealed = false;
  }
}
